const data = {
  filter: {
    title: "filter",
    pageName: "filter",
    genre: "filter",
    ignoreSaveFilter: true,
    hideFilter: true,
    filters: [
    ],
  },
  header: {
      title: "Credentials for Hash Lookup compatible APIs\n"
  },
  component: {
    type: "custom"
  },
};

export default data;
